import kebabCase from 'lodash/kebabCase';
import upperFirst from 'lodash/upperFirst';
import startCase from 'lodash/startCase';
import toUpper from 'lodash/toUpper';
import numberUtils from 'app/shared/utils/numberUtils';

function upperFirstEveryWord(string) {
    const words = string.split(' ');
    return words.map(upperFirst).join(' ');
}

const propertyUtils = {
    formatAddress(addressComponents) {
        const {
            street, city, state, unit, name, zip,
        } = addressComponents;

        // Transformations
        let formattedStreet = street ? upperFirstEveryWord(street) : '';
        const formattedCity = city ? startCase(city) : '';
        const formattedState = state ? toUpper(state) : '';
        const formattedUnit = unit ? toUpper(unit) : '';
        const formattedName = name ? upperFirstEveryWord(name) : '';

        if (unit && unit.length) {
            formattedStreet += ` ${formattedUnit}`;
        }

        const formattedAddress = [formattedStreet, formattedCity, formattedState].filter(val => val).join(', ');
        const formattedCityState = [formattedCity, formattedState].filter(val => val).join(', ');
        const formattedCityStateZip = `${formattedCityState} ${zip}`;
        const formattedCompleteAddress = [`${formattedStreet},`, formattedCityState, zip].filter(val => val).join(' ');
        const formattedKebobCase = kebabCase(formattedCompleteAddress);

        return {
            formattedAddress,
            formattedCityState,
            formattedCityStateZip,
            formattedCompleteAddress,
            formattedName,
            formattedStreet,
            formattedKebobCase,
        };
    },
    formatPropertyInfo(floorPlanDetails) {
        const {
            numBathrooms,
            numBedrooms,
            squareFeet,
            lowPrice,
        } = floorPlanDetails;

        const fields = [
            ...(numBedrooms ? [`${numBedrooms} beds`] : []),
            ...(numBathrooms ? [`${numBathrooms} baths`] : []),
            ...(squareFeet ? [`${squareFeet} sqft`] : []),
            ...(lowPrice ? [`${numberUtils.asCurrency(lowPrice)}/month`] : []),
        ];

        return fields.join(' · ');
    },
    /**
     * Consists of 2 lines:
     *
     * If Multi-family listing:
     *  - First Line: name OR fall back to street name
     *  - Second Line: Full Address
     *
     * If Single-family listing:
     *  - If no property info (ie. beds, bath, sqft, price)
     *      - First line: Street Name
     *      - Second Line: Full Address
     *  - if more than one property info field
     *      - First Line: Full Address
     *      - Second Line: Property Info
     */
    getPropertyInfoLines(listingData) {
        let firstLine;
        let secondLine;

        const {
            isCommunity,
            floorPlanDetails,
        } = listingData;

        const { formattedStreet, formattedAddress, formattedName } = this.formatAddress(listingData);

        if (isCommunity) {
            firstLine = formattedName || formattedStreet;
            secondLine = formattedAddress;
        } else {
            const {
                numBathrooms,
                numBedrooms,
                squareFeet,
                lowPrice,
            } = floorPlanDetails;

            if (!numBathrooms && !numBedrooms && !squareFeet && !lowPrice) {
                firstLine = formattedStreet;
                secondLine = formattedAddress;
            } else {
                firstLine = formattedAddress;
                secondLine = this.formatPropertyInfo(floorPlanDetails);
            }
        }

        return { firstLine, secondLine };
    },
    getListingId(feedId, feedListingId) {
        return `${feedListingId}_${feedId}`;
    },
    /**
     * getListingIdByPath
     *
     * @param {string} pathname
     *
     * @returns {string}  4btn2kr0nvhbz
     *
     * expects pathname format /rental-manager/properties/4btn2kr0nvhbz/listing
     */
    getListingIdByPath(pathname) {
        return pathname.split('/')[3];
    },
};

export default propertyUtils;
